import { fabric } from 'fabric';
import { useEditorData } from '../../lib/FabricJs';
import { useHandleHistory } from '../../lib/FabricJs/hooks/useHandleHistory';

// Objects in a multi-selection have coordinates relative to it, so the
// selection is taken apart, each object edited in slide coordinates, and the
// selection rebuilt. The edit is one undo step.
export const useSelectionEdit = () => {
  const { canvas } = useEditorData();
  const { handleHistory } = useHandleHistory();

  return (edit: (objects: fabric.Object[]) => void) => {
    if (!canvas) return;
    const objects = canvas.getActiveObjects();
    if (!objects.length) return;
    const isMultiple = objects.length > 1;
    if (isMultiple) canvas.discardActiveObject();
    edit(objects);
    objects.forEach((object) => object.setCoords());
    if (isMultiple) {
      canvas.setActiveObject(new fabric.ActiveSelection(objects, { canvas }));
    }
    canvas.requestRenderAll();
    handleHistory(canvas);
  };
};
